import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FileIcon from "../../../Icons/FileIcon";


function createData(id, item, file, expirationDate, status) {
  return { id, item, file, expirationDate, status };
}

const rows = [
  createData("1", "Current Resume", "Employment Info.pdf", "-", "Completed"),
  createData(
    "2",
    "Professional License",
    "Employment Info.pdf",
    "-",
    "Completed"
  ),
  createData("3", "CPR Card", "Employment Info.pdf", "-", "Completed"),
];

function ApplicantOfferOrientationTable() {
  return (
    <div>
      <TableContainer component={Paper} className="tableContainer">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: "#FAFAFB" }}>
            <TableRow>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] customTableHead"
              >
                #
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] customTableHead"
              >
                Item
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] customTableHead"
              >
                File
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] customTableHead"
              >
                Expiration Date
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] customTableHead"
              >
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left" className="customTableBody">
                  {row.id}
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  {row.item}
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  <div className="flex gap-2 ">
                    <FileIcon />
                    <span>{row.file}</span>
                  </div>
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  {row.expirationDate}
                </TableCell>
                <TableCell
                  align="left"
                  className="!text-[#32D583] font-bold customTableBody"
                  sx={{
                    fontWeight: 700,
                    fontSize: "0.75rem",
                  }}
                >
                  {row.status}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default ApplicantOfferOrientationTable;
